import React from 'react';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { useFormShowContext } from 'framework/form';
import { useAuthorization } from 'framework/authorization';
import { useIsMyProfile } from 'domain/shared/employee';
import { SxProps } from '@mui/material';

interface EditFormShowButtonProps {
  requiredPermission?: string | string[];
  disabled?: boolean;
  onClick?: () => void;
  sx?: SxProps;
}

const EditFormShowButton: React.FC<EditFormShowButtonProps> = ({ requiredPermission, sx, disabled, onClick }) => {
  const { toggleEditMode } = useFormShowContext();
  const { isGranted } = useAuthorization();
  const isMyProfile = useIsMyProfile();

  if (!requiredPermission || isMyProfile || !isGranted(requiredPermission)) {
    return null;
  }

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    toggleEditMode();
  };

  return (
    <IconButton sx={sx} onClick={handleClick} data-testid="edit-button" disabled={disabled}>
      <AppRegistrationIcon color="primary" />
    </IconButton>
  );
};

export default EditFormShowButton;
